import * as React from 'react';
import {
    TimeZone, TournamentConstraints,
    TournamentSchedule, TournamentScheduleTime,
} from '../../../../generated/protocol';
import { Condition } from '../../form/Condition';
import { CronSchedule } from '../../form/CronSchedule';
import { FormComponentProps } from '../../form/Form';
import { FormDatePicker } from '../../form/FormDatePicker';
import { FormGroup } from '../../form/FormGroup';
import { FormInput } from '../../form/FormInput';
import { FormTransferContainer } from '../../form/FormTransferContainer';
import { SelectInput } from '../../form/SelectInput';
import { Validators } from '../../form/Validators';
import { TournamentSchedulePreview } from './TournamentSchedulePreview';

interface TournamentScheduleProps extends FormComponentProps {
    constraints?: TournamentConstraints;
    timeZones?: TimeZone[]
    schedule?: TournamentSchedule;
    calculateSchedule?: (schedule: TournamentSchedule) => Promise<TournamentScheduleTime[]>;
}

export class TournamentScheduleComponent extends React.Component<TournamentScheduleProps, {}> {

    constructor(props) {
        super(props);

    }

    render() {
        return (
            <FormTransferContainer {...this.props}>
                <div className='row'>
                    <div className='col-lg-12'>
                        <div className='ibox float-e-margins'>
                            <div className='ibox-title'>
                                <h5>Schedule</h5>
                            </div>
                            <div className='ibox-content'>
                                <div className='hr-line-dashed'></div>

                                <FormGroup className='form-group'>
                                    <label className='col-sm-2 control-label'>Time Zone</label>
                                    <div className='col-sm-10'>
                                        <SelectInput className='form-control' displayValue={(t: TimeZone) => t.name}
                                                     sort={false}
                                                     optionModelValue={(t: TimeZone) => t.id}
                                                     values={this.props.timeZones} model='schedule.timeZoneId'/>
                                    </div>
                                </FormGroup>

                                <div className='hr-line-dashed'></div>




                                <FormGroup className='form-group' model='schedule.startDate'>
                                    <label className='col-sm-2 control-label'>Start Date</label>
                                    <div className='col-sm-10'>
                                        <FormDatePicker className='form-control'
                                                        timeZoneId={this.props.schedule.timeZoneId}
                                                        model='schedule.startDate'
                                                        validators={[Validators.required()]}/>
                                    </div>
                                </FormGroup>

                                <div className='hr-line-dashed'></div>

                                <FormGroup className='form-group' model='schedule.endDate'>
                                    <label className='col-sm-2 control-label'>End Date</label>
                                    <div className='col-sm-10'>
                                        <FormDatePicker className='form-control'
                                                        timeZoneId={this.props.schedule.timeZoneId}
                                                        model='schedule.endDate'
                                                        validators={[Validators.required()]}/>
                                    </div>
                                </FormGroup>

                                <div className='hr-line-dashed'></div>

                                <FormGroup className='form-group'>
                                    <label className='col-sm-2 control-label'>Advanced</label>
                                    <div className='col-sm-10'>
                                        <FormInput type='checkbox' model='schedule.advanced'/>
                                    </div>
                                </FormGroup>

                                <Condition show={this.props.schedule.advanced}>
                                    <FormGroup className='form-group' model='schedule.cronSchedule'>
                                        <label className='col-sm-2 control-label'>Cron Expression</label>
                                        <div className='col-sm-10'>
                                            <FormInput className='form-control cron-expression' type='text'
                                                       model='schedule.cronSchedule'/>
                                        </div>
                                    </FormGroup>
                                </Condition>

                                <Condition show={!this.props.schedule.advanced}>
                                    <FormGroup className='form-group' model='schedule.cronSchedule'>
                                        <label className='col-sm-2 control-label'>Schedule</label>
                                        <div className='col-sm-10'>
                                            <CronSchedule model='schedule.cronSchedule'/>
                                        </div>
                                    </FormGroup>
                                </Condition>

                                <div className='hr-line-dashed'></div>

                                <FormGroup className='form-group' model='schedule.minutesInAnnounced'>
                                    <label className='col-sm-2 control-label'>Announced</label>
                                    <div className='col-sm-10'>
                                        <FormInput type='integer' model='schedule.minutesInAnnounced'
                                                   className='form-control'
                                                   validators={[Validators.required(), Validators.integer()]}/>
                                        <span className='help-block'>
                                            How many minutes before registration opens the tournament
                                            should be visible in the lobby
                                        </span>
                                    </div>
                                </FormGroup>

                                <div className='hr-line-dashed'></div>

                                <FormGroup className='form-group' model='schedule.notificationMinutes'>
                                    <label className='col-sm-2 control-label'>Notification</label>
                                    <div className='col-sm-10'>
                                        <FormInput type='integer' model='schedule.notificationMinutes'
                                                   className='form-control'
                                                   validators={[Validators.required(), Validators.integer()]}/>
                                        <span className='help-block'>
                                            How many minutes before tournament start a notification is sent to
                                            all players (use 0 to disable notifications)
                                        </span>
                                    </div>
                                </FormGroup>

                                <div className='hr-line-dashed'></div>

                                <FormGroup className='form-group' model='schedule.minutesInRegistering'>
                                    <label className='col-sm-2 control-label'>Registering</label>
                                    <div className='col-sm-10'>
                                        <FormInput type='integer' model='schedule.minutesInRegistering'
                                                   className='form-control'
                                                   validators={[Validators.required(), Validators.integer()]}/>
                                        <span className='help-block'>
                                            How many minutes before the tournament starts it will be registering
                                        </span>
                                    </div>
                                </FormGroup>

                                <div className='hr-line-dashed'></div>

                                <FormGroup className='form-group' model='schedule.minutesVisibleAfterFinished'>
                                    <label className='col-sm-2 control-label'>Finished</label>
                                    <div className='col-sm-10'>
                                        <FormInput type='integer' model='schedule.minutesVisibleAfterFinished'
                                                   className='form-control'
                                                   validators={[Validators.required(), Validators.integer()]}/>
                                        <span className='help-block'>
                                            How many minutes it will be visible in the lobby after finishing
                                        </span>
                                    </div>
                                </FormGroup>

                                <div className='hr-line-dashed'></div>

                                <TournamentSchedulePreview calculateSchedule={this.props.calculateSchedule}
                                                           timeZones={this.props.timeZones}
                                                           schedule={this.props.schedule}/>

                                <div className='hr-line-dashed'></div>

                            </div>
                        </div>
                    </div>
                </div>
            </FormTransferContainer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/ui/poker/tournament/TournamentScheduleComponent.tsx